export default {
  bind: function (el, binding, vnode) {
    let ddToggle = el.querySelector('.dropdown-toggle');
    let ddMenu = el.querySelector('.dropdown-menu');
    el.vDropdown = Object.assign({}, binding.modifiers, binding.value);
    let closeOnMenuClick = () => el.vDropdown.closeOnMenuClick;
    let prevent = () => el.vDropdown.prevent;
    let noToggle = () => el.vDropdown.noToggle;
    let disabled = () => el.vDropdown.disabled;
    let showing = false;

    let emit = (vnode, name, data) => {
      let handlers = (vnode.data && vnode.data.on) ||
        (vnode.componentOptions && vnode.componentOptions.listeners);
      if (handlers && handlers[name]) {
        handlers[name].fns(data);
      }
    };

    ddToggle.addEventListener('click', function (evt) {
      if (prevent()) evt.preventDefault();
      let isShown = el.classList.contains('show');
      showing = (!isShown || noToggle()) && !disabled();
      if (showing !== isShown) {
        el.classList.toggle('show', showing);
        ddMenu.classList.toggle('show', showing);
        emit(vnode, 'dropdownToggle', showing);
      }
    });

    window.addEventListener('click', function () {
      if (!showing || disabled()) {
        el.classList.remove('show');
        ddMenu.classList.remove('show');
        emit(vnode, 'dropdownToggle', false);
      }
      showing = false;
    });

    ddMenu.addEventListener('click', function (evt) {
      showing = false;
      if (!closeOnMenuClick()) {
        evt.stopPropagation();
      }
    });
  },
  update: function (el, binding) {
    el.vDropdown = Object.assign({}, binding.modifiers, binding.value);
  },
};



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-directives/Dropdown.js